import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // 👈 asegurate que el nombre sea exacto
import './index.css'; // si no existe, podés comentarlo

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App /> {/* 👈 esto es lo que muestra la app */}
  </React.StrictMode>
);